import { useContext } from "react";
import { ChangePasswordActionContext } from "./ChangePasswordActionContext";

export default function usePrepareChangePassword() {
  const { setUserId, setShowModal, setFormData, setBackendFormErrors } = useContext(ChangePasswordActionContext);
  return (userId: number) => {
    setUserId(userId);
    setFormData({ password: "", password_confirmation: "" });
    setBackendFormErrors(null);
    setShowModal(true);
  };
}
